import React, { ReactElement } from 'react';
import { Translate } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Footer from '../../layout/Footer';
import YoutubeEmbed from './YoutubeEmbed';
import chevronDroite from '../../../img/icones/chevron_droite.svg';
import Modal from '../../common/modals/Modal';
import { HOME_PAGE_ROUTE } from '../../../routes';
import Button from '../../common/Button';
import Contact from './Contact';

const staticHelp = {
  profile: 'connected',
  helps: [{
    answer: 'OsUv4SeIyOk',
    creationDate: '2017-10-09',
    creationUser: null,
    id: 1050,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Activer mon identité numérique',
    type: 'VIDEO',
    typeAnswer: 'URL',
    updateDate: '2017-10-09',
    updateUser: null,
  }, {
    answer: '9sfakDmWGiA',
    creationDate: '2017-10-09',
    creationUser: null,
    id: 1000,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Créer mon identité numérique collaborateur',
    type: 'VIDEO',
    typeAnswer: 'URL',
    updateDate: '2017-10-09',
    updateUser: null,
  }, {
    answer: '6_dSLuyEN7k',
    creationDate: '2017-10-09',
    creationUser: null,
    id: 1350,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Effectuer une demande de rattachement',
    type: 'VIDEO',
    typeAnswer: 'URL',
    updateDate: '2017-10-09',
    updateUser: null,
  }, {
    answer: 'A2_KeJ7DeO8',
    creationDate: '2017-10-09',
    creationUser: null,
    id: 1300,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Valider une demande de rattachement',
    type: 'VIDEO',
    typeAnswer: 'URL',
    updateDate: '2017-10-09',
    updateUser: null,
  }, {
    answer: 'y2fQm0bnlsE',
    creationDate: '2017-10-09',
    creationUser: null,
    id: 1200,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Associer une protection mobile à mon compte',
    type: 'VIDEO',
    typeAnswer: 'URL',
    updateDate: '2017-10-09',
    updateUser: null,
  }, {
    answer: "<div><p>Oui.</p><p>Cette nouvelle version d'ID.NOT permet à chaque collaborateur de créer son identité numérique. (Lors de l'inscription, le collaborateur sélectionne son entité. Ce rattachement sera ensuite validé par le gestionnaire de l'entité)  </p></div>",
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1600,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Mon collaborateur peut-il créer son compte ID.NOT lui-même ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: "<div><p>Oui, à condition que le gestionnaire principal de l'entité l’ait préalablement habilité.</p><p>Pour ce faire, le gestionnaire principal doit se connecter à ID.NOT > Ouvrir la fiche du collaborateur  qu’il souhaite habiliter depuis la page \"Accès des membres\" > Cliquer sur le bouton « déléguer mes  droits » sur la carte du collaborateur à habiliter.</p><p>Le collaborateur habilité aura par la suite la possibilité de gérer les accès des membres, mais ne  pourra pas déléguer ses droits.</p></div>",
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1650,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Un collaborateur peut-il gérer les arrivées et départs des autres collaborateurs de  l’office ?  ',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Oui.</p><p>Tout gestionnaire ou collaborateur habilité dispose de ce droit.</p> <p>Pour ce faire, le gestionnaire doit se connecter à ID.NOT > Ouvrir la fiche du collaborateur qu’il  souhaite bloquer depuis la page "Accès des membres" > Cliquer sur le bouton « bloquer » sur la carte  du collaborateur à bloquer.</p> <p>Le compte du collaborateur concerné est ainsi bloqué sur toutes les applications ID.NOT de l’entité  ayant engagé l’action.</p> <p>Si le collaborateur travaille dans une autre entité, son compte reste actif pour un usage strict de la  seconde entité.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1700,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Est-il possible de bloquer provisoirement un compte collaborateur ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Seul un administrateur habilité du Conseil Supérieur du Notariat est autorisé à le faire, dans des  circonstances exceptionnelles.</p><p>Tous les comptes des notaires sont pilotés par les publications au Journal Officiel, inscrites dans le  FICEN (Fichier Central des Notaires opéré par le Conseil Supérieur du Notariat)</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1750,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment puis-je supprimer mon compte notaire ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Comment supprimer le rattachement d\'un collaborateur à une entité ?</p><p>Tout gestionnaire principal ou gestionnaire délégué dispose de ce droit.</p><p>Pour ce faire, le gestionnaire doit se connecter à ID.NOT > Ouvrir la fiche du collaborateur dont il  souhaite supprimer le rattachement depuis la page "Accès des membres" > Cliquer sur le bouton «  Déclarer le départ » sur la carte du collaborateur.</p><p>Le collaborateur concerné ne pourra plus utiliser l’ensemble des applications utilisant ID.NOT pour le  compte de l’entité.</p><p>Si le collaborateur travaille dans une autre entité, son compte reste actif pour un usage strict de la  seconde entité.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1800,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment déclarer le départ d’un collaborateur ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Non.</p><p>L’identité numérique comme son nom l’indique permet de créer un compte par personne, peu  importe le nombre d’employeurs dans la profession.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1850,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Je travaille dans plusieurs offices. Dois-je créer plusieurs comptes ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Non.</p><p>L’identité numérique comme son nom l’indique permet de créer un compte par personne, peu  importe le nombre de mandats dont le notaire dispose.</p><p>La gestion des mandats des notaires au sein des instances de la profession est pilotée dans le FICEN.  Vous pourrez utiliser les applications de votre instance avec votre compte ID.NOT dès lors que votre  mandat aura été déclaré dans le FICEN par le secrétaire général de votre instance.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1900,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Je suis notaire et j’ai un mandat dans une Instance. Dois-je créer plusieurs comptes ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Il dispose de plusieurs solutions.</p><p>1. Il renseigne le formulaire de contact accessible depuis la mire d’authentification > cliquer sur "Je  n\'ai pas d\'identité" > "Activer mon identité > Je n’ai pas reçu de courrier > "Demander mon code".</p><p>2. Il contacte la Hotline ADSN au 0 800 306 212.</p><p>3. Il contacte son Responsable Régional ADSN qui dispose des moyens et autorisations nécessaires  pour lui communiquer son code d’activation.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 1950,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Mon associé n’a pas reçu le pli scellé avec son code d’activation ? Que doit-il faire ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Pour des raisons de sécurité.</p><p>Il convient d’être absolument certain d’être le seul à recevoir les notifications mails qui seront  transmises sur cette adresse, à savoir les mails d’activation du compte et de réinitialisation du mot  de passe.</p><p>L’utilisation d’une boîte mail à laquelle plusieurs personnes peuvent accéder peut compromettre  l’intégrité de votre compte.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2000,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Pourquoi avoir permis d’utiliser une adresse mail personnelle pour créer un compte  ID.NOT ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>L’adresse mail personnelle associée à votre identité numérique permet uniquement de gérer  l’activation du compte,la réinitialisation du mot de passe et la récupération de l’identifiant de  connexion.</p><p>Cette adresse mail peut être issue de différents fournisseurs de messagerie (Gmail, Yahoo…etc.). Elle  ne sera jamais communiquée à personne.</p><p>L’adresse mail professionnelle quant à elle pourra être diffusée aux applications de la profession  pour répondre à des besoins fonctionnels. De ce fait, il est nécessaire de mettre une adresse  respectant le plan de nommage de la profession.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2050,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Pourquoi est-ce que je ne peux pas mettre mon adresse mail personnelle dans les  informations professionnelles ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Vous pouvez accéder à votre compte ID.NOT en utilisant le navigateur de votre mobile.</p><h3>Attention</h3><p>Ne pas confondre avec l’application ID.NOT Authenticator téléchargée sur le store qui est  un authentificateur permettant de renforcer la sécurité d’accès à votre compte si la fonction a été  activée.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2150,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment accéder à mon compte ID.NOT depuis mon mobile ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>ID.NOT est le moyen permettant de vous identifier, de gérer votre compte.</p><p>Notaccess est une application (qui présente tous les outils de la profession). Notaccess utilise le moyen d’authentification ID.NOT, au même titre que Radar, Oscar, Formacen  …etc.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2200,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Quelle est la différence entre ID.NOT et Notaccess ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Non.</p><p>La clé Réal reste le moyen d’authentification disposant du degré de sécurité le plus élevé.Il est fourni au travers d’un support physique et est destiné à un usage « cœur de métier » (signature  électronique notamment).</p><p>ID.NOT est également un moyen d’authentification sécurisé, sans support physique.  Il est destiné aux applications hors du domaine « cœur de métier » et est utilisable en mobilité.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2250,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Est-ce que ID.NOT remplace la clé Réal ?  ',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Vous pouvez à tout moment changer votre identifiant de connexion en cliquant sur "identifiants de  connexion" sur la page d\'accueil de Mon Compte ID.NOT.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2300,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment changer mon identifiant de connexion ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Vous pouvez à tout moment changer votre mot de passe en cliquant sur "Mot de passe" sur la page  d\'accueil de Mon Compte ID.NOT > Renseigner l\'ancien mot de passe > Renseigner le nouveau mot  de passe et sa confirmation > Valider.</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2350,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment changer mon mot de passe ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Télécharger l’application ID.NOT Authenticator depuis le store puis suivez les instructions qui figurent  sur votre PC : page d\'accueil de Mon Compte ID.NOT « Renforcement de la sécurité > Associer un  appareil à mon compte».</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2400,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment renforcer la sécurité d’accès à mon compte ID.NOT ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }, {
    answer: '<div><p>Sur la page d\'accueil, partie "Renforcement de la sécurité" > Mettre l\'interrupteur/bouton  "Authentification renforcée" à "Non".</p></div>',
    creationDate: '2017-04-26',
    creationUser: null,
    id: 2450,
    profils: [{
      appId: 1000, creationDate: '2017-06-14', id: 1050, name: 'connected',
    }],
    title: 'Comment désactiver l’authentification renforcée ?',
    type: 'QA',
    typeAnswer: 'HTML',
    updateDate: '2017-04-26',
    updateUser: null,
  }],
};

type Props = RouteComponentProps & {
};

type State = {
  showAnswer: number,
  url: string,
  isYoutubeModalOpen: boolean,
};

class Aide extends React.Component<Props, State> {
  state: State = {
    showAnswer: null,
    url: null,
    isYoutubeModalOpen: false,
  };

  componentDidMount(): void {
    document.body.scrollIntoView();
  }

  showAnswer = (id: number): void => {
    if (id !== this.state.showAnswer) {
      this.setState({ showAnswer: id });
    } else this.setState({ showAnswer: null });
  };

  openYoutubeModal = (url: string):void => {
    this.setState({ url, isYoutubeModalOpen: true });
  };

  onClose = ():void => {
    this.setState({ url: null, isYoutubeModalOpen: false });
  };

  render(): ReactElement {
    const userHelp = staticHelp;
    const qaHelps = userHelp.helps
      .filter((help) => help.type === 'QA')
      .map((help) => ({
        id: help.id,
        answer: help.answer,
        question: help.title,
      }));
    const videoHelps = userHelp.helps
      .filter((help) => help.type === 'VIDEO')
      .map((help) => ({
        id: help.id,
        url: help.answer,
        question: help.title,
      }));
    return (
      <div className="static-page">
        <div className="static-content">
          <Modal className="youtube-modal" isOpen={this.state.isYoutubeModalOpen} onClose={this.onClose}>
            <YoutubeEmbed
              embedId={this.state.url}
            />
          </Modal>
          <div className="back-button-container">
            <Button
              type="back"
              buttonType="button"
              onClick={() => this.props.history.push(HOME_PAGE_ROUTE)}
            >
              <i className="fa fa-angle-left fa-2x" />
              <Translate value="actions.BACK" />
            </Button>
          </div>
          <h1 className="static-title">
            <i className="fa fa-file-text-o" />
            <Translate value="FOOTER.HELP" />
          </h1>
          <div className="static-body">
            <div className="videos-grid">
              {videoHelps.map((videoHelp) => (
                <div key={videoHelp.id} className="video-frame">
                  <h3>{videoHelp.question}</h3>
                  <button type="button" onClick={() => this.openYoutubeModal(videoHelp.url)}>
                    <img src={`http://i1.ytimg.com/vi/${videoHelp.url}/default.jpg`} alt="miniature" />
                  </button>
                </div>
              ))}
            </div>
            {qaHelps.map((qaHelp) => (
              <div key={qaHelp.id} className="qa-item">
                <button type="button" onClick={() => this.showAnswer(qaHelp.id)}>
                  <h2 className="qa-question">
                    {qaHelp.question}
                    <img
                      className={`chevron ${this.state.showAnswer === qaHelp.id ? 'face-bottom' : ''}`}
                      src={chevronDroite}
                      alt="chevron"
                    />
                  </h2>
                </button>
                {this.state.showAnswer === qaHelp.id
                && <div className="qa-answer" dangerouslySetInnerHTML={{ __html: qaHelp.answer }} />}
              </div>
            ))}
            <Contact />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Aide);
